import clsx from "clsx";
import type { ButtonHTMLAttributes, PropsWithChildren } from "react";
import { buttonVariants, ButtonVariantsProps } from "@/components/form/buttonVariants";

type Props = ButtonHTMLAttributes<HTMLButtonElement> &
    ButtonVariantsProps &
    PropsWithChildren & {
        className?: string;
    };

export function Button({ content, theme, fullWidth = true, children, className, ...props }: Props) {
    const handleContextMenu = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
    };

    // For trivia buttons, ensure text-black is applied and text-white is removed
    const buttonStyles = buttonVariants({ content, theme, fullWidth });
    return (
        <button type="button" className={clsx(buttonStyles, className)} onContextMenu={handleContextMenu} {...props}>
            {children}
        </button>
    );
}

export default Button;
